export enum Orientation {
  Vertical = 'Vertical',
  Horizontal = 'Horizontal',
}
